import { Routes, Route, Navigate } from 'react-router-dom';

import useToken from '../../common/hooks/useToken';
import useUserName from '../../common/hooks/useUserName';
import usePcode from '../../common/hooks/usePcode';
import useUserMode from '../../common/hooks/useUserMode';

import MainMenu from './mainMenu';

import LogIn from '../../components/logIn';
import { useEffect, useRef, useState } from 'react';

export default function Room() {
    const { token, setToken } = useToken();
    const { userName, setLogedUserName } = useUserName();
    const { setLoggedPCode } = usePcode();
    const { userMode,setLogedUserMode } = useUserMode();

    const isMount = useRef(false);
    const [logOutDone, setLogOutDone] = useState(false);

    useEffect(() => {
        if (isMount.current === false) {
            isMount.current = true;

            if (userMode !== null && userMode !== undefined)
                logOut();
            setLogOutDone(true);
        }
    }, [])

    const logOut = () => {
        setToken('');
        setLogedUserName('');
        setLoggedPCode('');
        setLogedUserMode('');
    }

    if (logOutDone) { 
        if (!token)
            return <LogIn setToken={setToken} setLogedUserName={setLogedUserName} setLoggedPcode={setLoggedPCode} logInType={'Guest'} logInTitle={"Guest"}
                userNamePlaceHolder={'Table #'} setLogedUserMode={setLogedUserMode} />;
        else
            return <Navigate to="/postouch" state={{
                selectedTableNo: userName, backNavigationPath: "/",
                selectedRoomNo: '',
                selectedMode: `Guest - ${userName}`,
                selectedLocCode: ''
            }} />
    }
}